// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes placeHolderShimmer-ecb56986{0%{background-position:-468px 0}to{background-position:350px 50px}}.skeleton.base[data-v-ecb56986]{animation-duration:1s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:placeHolderShimmer-ecb56986;animation-timing-function:linear;background-color:#dcdee2;background-repeat:repeat;background-size:800px 104px;height:100%;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
